import { motion } from 'framer-motion'
import DocsLayout from '../components/DocsLayout'
import SEO from '../components/SEO'
import {
  FaApple,
  FaCogs,
  FaSyncAlt,
  FaLock,
  FaDesktop,
  FaDownload,
  FaEdit,
  FaTerminal,
  FaArchive,
  FaRocket,
  FaCompactDisc,
  FaKey,
  FaWindows,
  FaTools,
  FaMusic,
  FaPlay,
  FaFileWord,
  FaCheckSquare,
  FaCamera,
  FaShieldAlt,
  FaCode,
  FaFilm,
  FaUsb
} from 'react-icons/fa'

const softwareCategories = [
  {
    name: "音频",
    icon: <FaMusic className="text-blue-500" />,
    software: [
      {
        name: "Spotify",
        description: "全球最大的音乐流媒体服务，提供数百万首歌曲和播客。",
        url: "https://www.spotify.com/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Apple Music",
        description: "苹果官方音乐流媒体服务，与 iOS 设备深度集成。",
        url: "https://www.apple.com/apple-music/",
        isPremium: true
      },
      {
        name: "VOX",
        description: "优雅简洁的音乐播放器，支持高解析度音频格式。",
        url: "https://vox.rocks/mac-music-player",
        isFree: true,
        isPremium: true
      },
      {
        name: "Audacity",
        description: "一款免费开源的多轨音频编辑软件。",
        url: "https://www.audacityteam.org/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "CastLoom Pro",
        description: "播客软件。从播客到知识库，一步到位。播放、下载、转录、翻译、归档，支持 Windows 与 macOS，7 天免费试用，一次购买终身授权。",
        url: "https://castloompro.toolooz.com/",
        isPremium: true
      }
    ]
  },
  {
    name: "影视",
    icon: <FaPlay className="text-red-500" />,
    software: [
      {
        name: "IINA",
        description: "现代化的 macOS 视频播放器，基于 mpv，界面美观，功能丰富。",
        url: "https://iina.io/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "VLC",
        description: "跨平台多媒体播放器，几乎可以播放任何视频格式。",
        url: "https://www.videolan.org/vlc/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Elmedia Player",
        description: "功能丰富的视频播放器，支持字幕、AirPlay 和 Chromecast 投屏。",
        url: "https://mac.eltima.com/media-player.html",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "办公",
    icon: <FaFileWord className="text-indigo-600" />,
    software: [
      {
        name: "Microsoft Office",
        description: "微软办公套件，包含 Word、Excel、PowerPoint 等应用。",
        url: "https://www.microsoft.com/microsoft-365",
        isPremium: true
      },
      {
        name: "Pages/Numbers/Keynote",
        description: "苹果官方办公套件，与 macOS 和 iOS 深度集成，支持 iCloud 同步。",
        url: "https://www.apple.com/iwork/",
        isFree: true
      },
      {
        name: "LibreOffice",
        description: "功能强大的开源办公套件，免费替代 Microsoft Office。",
        url: "https://www.libreoffice.org/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Google Workspace",
        description: "Google 的在线办公套件，包含文档、表格、演示文稿等工具。",
        url: "https://workspace.google.com/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "写作",
    icon: <FaEdit className="text-green-600" />,
    software: [
      {
        name: "Ulysses",
        description: "优雅的写作应用，专为写作者设计，支持 Markdown。",
        url: "https://ulysses.app/",
        isPremium: true
      },
      {
        name: "Bear",
        description: "美观易用的笔记应用，支持 Markdown 和标签管理。",
        url: "https://bear.app/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Notion",
        description: "全能型工作区，集笔记、知识库、任务管理于一身。",
        url: "https://www.notion.so/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Obsidian",
        description: "强大的知识库应用，基于本地 Markdown 文件。",
        url: "https://obsidian.md/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "效率",
    icon: <FaCheckSquare className="text-orange-500" />,
    software: [
      {
        name: "Alfred",
        description: "强大的生产力工具，可替代 Spotlight，支持工作流和自动化。",
        url: "https://www.alfredapp.com/",
        isFree: true,
        isPremium: true
      },
      {
        name: "Things",
        description: "优雅的任务管理工具，简洁易用，与苹果生态系统深度集成。",
        url: "https://culturedcode.com/things/",
        isPremium: true
      },
      {
        name: "Magnet",
        description: "窗口管理工具，轻松排列和组织窗口。",
        url: "https://magnet.crowdcafe.com/",
        isPremium: true
      },
      {
        name: "Rectangle",
        description: "免费开源的窗口管理工具，可通过键盘快捷键调整窗口大小和位置。",
        url: "https://rectangleapp.com/",
        isFree: true,
        isOpenSource: true
      }
    ]
  },
  {
    name: "安全",
    icon: <FaShieldAlt className="text-red-600" />,
    software: [
      {
        name: "CleanMyMac X",
        description: "全面的 Mac 清理和优化工具，帮助释放空间和保持系统流畅。",
        url: "https://macpaw.com/cleanmymac",
        isPremium: true
      },
      {
        name: "Little Snitch",
        description: "网络监控工具，可控制应用程序的网络连接。",
        url: "https://www.obdev.at/products/littlesnitch/",
        isPremium: true
      },
      {
        name: "Malwarebytes",
        description: "专业恶意软件检测和清除工具。",
        url: "https://www.malwarebytes.com/mac/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "压缩",
    icon: <FaArchive className="text-yellow-600" />,
    software: [
      {
        name: "The Unarchiver",
        description: "功能强大的解压缩工具，支持几乎所有压缩格式。",
        url: "https://theunarchiver.com/",
        isFree: true
      },
      {
        name: "Keka",
        description: "开源的文件压缩工具，支持多种格式，界面简洁。",
        url: "https://www.keka.io/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "BetterZip",
        description: "专业的文件归档管理器，可预览和编辑压缩文件内容。",
        url: "https://macitbetter.com/",
        isPremium: true
      }
    ]
  },
  {
    name: "截图",
    icon: <FaCamera className="text-purple-500" />,
    software: [
      {
        name: "Shottr",
        description: "一款小巧而快速的 Mac 截图工具，具有注释、精美背景、滚动截图和云上传功能。",
        url: "https://shottr.cc",
        isFree: true
      },
      {
        name: "CleanShot X",
        description: "功能全面的屏幕捕获工具，可录制、标注和快速分享截图。",
        url: "https://cleanshot.com/",
        isPremium: true
      },
      {
        name: "Monosnap",
        description: "免费的截图和屏幕录制工具，支持云存储和快速分享。",
        url: "https://monosnap.com/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "开发",
    icon: <FaCode className="text-blue-700" />,
    software: [
      {
        name: "Visual Studio Code",
        description: "微软开发的免费开源代码编辑器，轻量级但功能强大。",
        url: "https://code.visualstudio.com/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "JetBrains 系列",
        description: "专业IDE工具集，包括 IntelliJ IDEA、WebStorm、PyCharm 等。",
        url: "https://www.jetbrains.com/",
        isPremium: true
      },
      {
        name: "Xcode",
        description: "苹果官方开发环境，用于开发 macOS、iOS、watchOS 和 tvOS 应用。",
        url: "https://developer.apple.com/xcode/",
        isFree: true
      },
      {
        name: "GitHub Desktop",
        description: "GitHub 官方桌面客户端，简化 Git 和 GitHub 工作流程。",
        url: "https://desktop.github.com/",
        isFree: true,
        isOpenSource: true
      }
    ]
  },
  {
    name: "终端",
    icon: <FaTerminal className="text-gray-800" />,
    software: [
      {
        name: "iTerm2",
        description: "macOS 终端的强大替代品，支持分屏、搜索、自动补全等功能。",
        url: "https://iterm2.com/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Homebrew",
        description: "macOS 的包管理器，让安装各种开发工具和应用变得简单。",
        url: "https://brew.sh/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Oh My Zsh",
        description: "Zsh 配置管理框架，提供丰富的主题和插件。",
        url: "https://ohmyz.sh/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Warp",
        description: "现代化的云端终端，支持AI辅助、合作分享等新功能。",
        url: "https://www.warp.dev/",
        isFree: true,
        isPremium: true
      }
    ]
  },
  {
    name: "系统工具",
    icon: <FaCogs className="text-gray-600" />,
    software: [
      {
        name: "Amphetamine",
        description: "保持 Mac 持续唤醒的工具，可自定义触发条件。",
        url: "https://apps.apple.com/us/app/amphetamine/id937984704",
        isFree: true
      },
      {
        name: "AppCleaner",
        description: "彻底卸载应用程序的工具，可清除相关文件。",
        url: "https://freemacsoft.net/appcleaner/",
        isFree: true
      },
      {
        name: "Time Machine",
        description: "macOS 内置的备份工具，可自动备份系统和文件。",
        url: "https://support.apple.com/zh-cn/HT201250",
        isFree: true
      },
      {
        name: "Bartender",
        description: "菜单栏管理工具，可隐藏和重组菜单栏图标。",
        url: "https://www.macbartender.com/",
        isPremium: true
      }
    ]
  },
  {
    name: "浏览器",
    icon: <FaDesktop className="text-blue-400" />,
    software: [
      {
        name: "Safari",
        description: "macOS 内置浏览器，与苹果生态系统深度集成，注重隐私和续航。",
        url: "https://www.apple.com/safari/",
        isFree: true
      },
      {
        name: "Chrome",
        description: "Google 开发的浏览器，拥有庞大的扩展生态。",
        url: "https://www.google.com/chrome/",
        isFree: true
      },
      {
        name: "Firefox",
        description: "Mozilla 基金会开发的开源浏览器，注重隐私和定制性。",
        url: "https://www.mozilla.org/firefox/",
        isFree: true,
        isOpenSource: true
      },
      {
        name: "Arc",
        description: "重新定义浏览器体验的创新浏览器，空间管理和美观界面。",
        url: "https://arc.net/",
        isFree: true
      }
    ]
  }
]

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
]

const MacOSSoftware = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="MacOS软件推荐"
        description="精选MacOS平台优质软件推荐，包括系统工具、办公软件、开发工具等，帮助你打造完美的Mac使用体验。"
        keywords="Mac软件,MacOS工具,Mac办公软件,Mac开发工具,Mac实用工具,Mac免费软件"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center flex items-center justify-center"
      >
        <FaApple className="mr-3 text-primary" />
        macOS 软件推荐
      </motion.h1>
      
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-gray-600 mb-8 text-center"
      >
        这里收集了各类 macOS 平台优质软件，帮助你打造高效实用的 Mac 使用环境。
      </motion.p>
      
      <div className="space-y-12">
        {softwareCategories.map((category, categoryIndex) => (
          <motion.div 
            key={category.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: categoryIndex * 0.1 }}
            className="bg-white shadow-md rounded-xl overflow-hidden hover:shadow-lg transition-shadow duration-300"
          >
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 flex items-center border-b border-blue-100">
              <div className="text-2xl p-3 bg-white rounded-full shadow-sm mr-4">{category.icon}</div>
              <h2 className="text-2xl font-bold text-gray-800">{category.name}</h2>
            </div>
            
            <div className="divide-y divide-gray-100">
              {category.software.map((software, index) => (
                <motion.div 
                  key={software.name} 
                  className="p-5 hover:bg-gray-50 transition-colors"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.1 * index + categoryIndex * 0.05 }}
                >
                  <div className="flex justify-between items-start">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">{software.name}</h3>
                    <div className="flex space-x-1">
                      {software.isFree && (
                        <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full font-medium">免费</span>
                      )}
                      {software.isPremium && (
                        <span className="px-2 py-1 bg-purple-100 text-purple-800 text-xs rounded-full font-medium">付费</span>
                      )}
                      {software.hasAds && (
                        <span className="px-2 py-1 bg-yellow-100 text-yellow-800 text-xs rounded-full font-medium">有广告</span>
                      )}
                      {software.isOpenSource && (
                        <span className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full font-medium">开源</span>
                      )}
                    </div>
                  </div>
                  <p className="text-gray-600 text-sm mb-3">{software.description}</p>
                  <a
                    href={software.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-primary hover:text-primary-dark text-sm font-medium transition-colors duration-200"
                  >
                    访问官网
                    <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </a>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </DocsLayout>
  )
}

export default MacOSSoftware 